import a, { forwardRef as m } from "react";
import { useTheme as f, Chip as b } from "@mui/material";
import { g as C } from "./chunk.BurCwd5X.js";
import { I as p } from "./chunk.zlc_6vey.js";
import { I as c, E as z, W as y } from "./chunk.9nF0J5xs.js";
import { jsx as h } from "react/jsx-runtime";
import { createSvgIcon as k } from "@mui/material/utils";
import { C as $ } from "./chunk.hn4xKC_I.js";
const S = k(/* @__PURE__ */ h("path", {
  d: "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0 2c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10m-1-10v4h2v-4h3l-4-4-4 4z"
}), "ArrowCircleUpOutlined");
function v(t, e) {
  switch (t) {
    case "positive":
      return {
        icon: /* @__PURE__ */ a.createElement(
          $,
          {
            sx: { color: `${e.palette.success.dark} !important` }
          }
        ),
        bgColor: e.palette.success.light,
        border: `1px solid ${e.palette.success.dark}`,
        textColor: e.palette.success.dark
      };
    case "neutral":
      return {
        icon: /* @__PURE__ */ a.createElement(
          c,
          {
            sx: { color: `${e.palette.grey[800]} !important` }
          }
        ),
        bgColor: e.palette.grey[200],
        border: `1px solid ${e.palette.grey[800]}`,
        textColor: e.palette.grey[800]
      };
    case "warning":
      return {
        icon: /* @__PURE__ */ a.createElement(
          y,
          {
            sx: { color: `${e.palette.warning.dark} !important` }
          }
        ),
        bgColor: e.palette.warning.light,
        border: `1px solid ${e.palette.warning.main}`,
        textColor: e.palette.warning.dark
      };
    case "urgent":
      return {
        icon: /* @__PURE__ */ a.createElement(
          S,
          {
            sx: { color: `${e.palette.urgent.dark} !important` }
          }
        ),
        bgColor: e.palette.urgent.light,
        border: `1px solid ${e.palette.urgent.dark}`,
        textColor: e.palette.urgent.dark
      };
    case "negative":
      return {
        icon: /* @__PURE__ */ a.createElement(
          z,
          {
            sx: { color: `${e.palette.error.dark} !important` }
          }
        ),
        bgColor: e.palette.error.light,
        border: `1px solid ${e.palette.error.dark}`,
        textColor: e.palette.error.dark
      };
    case "information":
      return {
        icon: /* @__PURE__ */ a.createElement(
          c,
          {
            sx: { color: `${e.palette.info.dark} !important` }
          }
        ),
        bgColor: e.palette.info.light,
        border: `1px solid ${e.palette.info.dark}`,
        textColor: e.palette.info.dark
      };
  }
}
const A = m(
  (t, e) => {
    const n = f(), l = t.size === "medium" ? "14px" : t.size === "large" ? "18px" : "12px", r = t.size === "medium" ? "20px" : t.size === "large" ? "24px" : "16px", i = t.variant === "status" ? v(t.severity, n) : null, g = () => ({
      borderRadius: "4px",
      border: `1px solid ${n.palette.grey[400]}`,
      background: `${n.palette.grey[200]}`,
      height: s(),
      padding: t.density === "compact" ? "4px 8px" : "8px 16px",
      ".MuiChip-label": {
        padding: 0,
        paddingLeft: t.icon ? "4px" : 0,
        fontSize: l,
        fontWeight: `${n.typography.subtitle2.fontWeight}`
      },
      ".MuiChip-icon": {
        margin: 0,
        width: r,
        height: r,
        fontSize: r
      }
    }), d = () => ({
      borderRadius: "4px",
      background: t.density === "light" ? "transparent" : i == null ? void 0 : i.bgColor,
      border: t.density === "light" ? "none" : `${i == null ? void 0 : i.border}`,
      height: u(),
      padding: t.density === "compact" ? "4px 8px" : t.density === "light" ? 0 : "8px 16px",
      color: i == null ? void 0 : i.textColor,
      span: {
        padding: 0,
        paddingLeft: t.icon ? "4px" : 0,
        fontWeight: `${n.typography.subtitle2.fontWeight}`,
        fontSize: l
      },
      ".MuiChip-icon": {
        margin: 0,
        width: r,
        height: r
      }
    }), u = () => t.size === "medium" || t.size === "large" ? t.density === "compact" ? "32px" : t.density === "light" ? "24px" : "40px" : t.density === "compact" ? "24px" : t.density === "light" ? "16px" : "32px", s = () => t.size === "medium" || t.size === "large" ? t.density === "compact" ? "32px" : "40px" : t.density === "compact" ? "24px" : "32px", x = () => {
      if (t.variant === "status")
        return i == null ? void 0 : i.icon;
      if (t.variant === "categorization") {
        const o = {
          icon: t.icon,
          variant: t.iconVariant
        };
        return /* @__PURE__ */ a.createElement(p, { ...o });
      }
    };
    return /* @__PURE__ */ a.createElement(
      b,
      {
        id: t.id,
        variant: t.variant === "categorization" ? "outlined" : "filled",
        label: t.label,
        sx: t.variant === "categorization" ? g() : d(),
        size: t.size === "medium" || t.size === "large" ? "medium" : "small",
        icon: t.icon ? x() : void 0,
        ref: e,
        onBlur: t.onBlur,
        onFocus: t.onFocus,
        onMouseOver: t.onMouseOver,
        onMouseLeave: t.onMouseLeave,
        ...C(e)
      }
    );
  }
);
export {
  A as T
};
